import React, { useState } from "react"
import Proptypes from "prop-types"
import { Row, Col, Button } from "reactstrap"
import { Modal } from "react-bootstrap"
import EachFeature from "../../Realtime/eachProductFeature"
import ContactUs from "../../ContactUs/contactUs"

const ServiceFeatures = props => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <div className="grid-view">
      {!props.noHeader ? (
        <Row className="text-wrapper">
          <Col className="service-about">
            <div className="heading large-font">{props.title}</div>
            <div className="description medium-font">{props.description}</div>
            {props.bottomTitle ? (
              <div className="heading heading-bottom large-font">
                {props.bottomTitle}
              </div>
            ) : (
              ""
            )}
            {props.noButton ? (
              ""
            ) : (
              <div className="button-container">
                <Button
                  className="small-font"
                  color="green"
                  onClick={handleShow}
                >
                  CONTACT SALES
                </Button>
              </div>
            )}
          </Col>
          {/* {props.noButton?'':
            <Col sm="3" className="button-container">
                <Button className="small-font" color="green" href=" " >CONTACT SALES</Button>
            </Col>
            } */}
        </Row>
      ) : (
        ""
      )}
      <Row className="service-grid-wrapper">
        {!props.twoCol
          ? props.data.map(data => (
              <Col
                md="4"
                sm="12"
                className="service-feature-wrapper bottom-border right-border"
              >
                <EachFeature
                  title={data.title}
                  description={data.description}
                  img={data.img}
                />
              </Col>
            ))
          : props.data.map(data => (
              <Col
                md="6"
                sm="12"
                className="service-feature-wrapper bottom-border right-border two-col"
              >
                <EachFeature
                  title={data.title}
                  description={data.description}
                  img={data.img}
                  link={data.link}
                  linkTitle={props.linkTitle}
                />
              </Col>
            ))}
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton />
        <ContactUs />
      </Modal>
    </div>
  )
}

ServiceFeatures.prototype = {
  data: Proptypes.any,
  title: Proptypes.any,
  description: Proptypes.any,
  twoCol: Proptypes.any,
  noButton: Proptypes.any,
  noHeader: Proptypes.any,
}

export default ServiceFeatures
